import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ProfileNav from './ProfileNav';
import LeftPane from './LeftPane';
import RightPane from './RightPane';
import { useGlobalContext } from '../../appContext';

const Profile = () => {
    const [profileData, setProfileData] = useState({});
    const { setAuthorSlug, peopleData } = useGlobalContext();
    const { pathname } = useLocation();
    const memberTypeFromLocation = pathname.split('/')[2];
    const slugFromLocation = pathname.split('/')[3];

    const profileNavData = { pathname, profileData };
    const leftPaneData = {
        profileData,
        slugFromLocation,
        memberTypeFromLocation,
    };

    useEffect(() => {
        window && window.scrollTo(0, 0);
      }, []);

    useEffect(() => {
        setAuthorSlug(slugFromLocation);
        const filteredPerson = peopleData.filter(
            (person) => person.slug === slugFromLocation
        );
        setProfileData(filteredPerson);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname, slugFromLocation]);

    return (
        <main className='person-main'>
            <ProfileNav {...profileNavData} />
            <section className='person-profile'>
                <section className='left-pane'>
                    <LeftPane {...leftPaneData} />
                </section>

                <section className='right-pane'>
                    <RightPane />
                </section>
            </section>
        </main>
    );
};

export default Profile;
